module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Figure-6af035e49a4be25854f4f9b04c97a39c.png";